import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function IhreIdeeAlsNaechstesProjekt() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="61795" id="individuelle-beratung-anfordern" className="relative w-full py-32 md:py-48 overflow-hidden bg-secondary">
      {}
      <div className="absolute inset-0 w-full h-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1594803/img/baggerarbeiten.png)] bg-cover bg-center bg-no-repeat" />
      
      {}
      <div className="absolute inset-0 bg-secondary/90 mix-blend-multiply" />
      <div className="absolute inset-0 bg-black/40" />

      <div ref={ref} className={`relative z-10 container mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <span className="inline-block mb-4 text-primary font-mono font-bold tracking-widest uppercase text-xs md:text-sm">
          Spezialprojekt?
        </span>
        
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white mb-8 tracking-tighter max-w-4xl mx-auto leading-tight uppercase">
          Individuelle Beratung für Ihr Bauvorhaben.
        </h2>
        
        <p className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl mx-auto font-normal leading-relaxed">&nbsp;Wir verwandeln Ihre Pläne in solide Realität – schnell, zuverlässig und regional.</p>
        
        <div className="flex justify-center">
          <Button asChild size="lg" className="text-lg px-10 py-8 h-auto bg-primary hover:bg-primary/90 text-white border-none shadow-2xl hover:shadow-primary/40 transition-all rounded-sm group">
            <Link to="/ContactPage">
              Jetzt Projekt anfragen
              <ArrowRight className="ml-2 size-6 transition-transform group-hover:translate-x-2" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}